import React from "react";
import { useLocation, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toggleMobileTooltip } from "helpers";
import {useEmbedHost, useIsIframe, useIsWhosfan, useMobile} from "MobileContext";
import HeaderNav from "components/nav/HeaderNav.js";

const Header = () => {
  const { t } = useTranslation();
  const isMobile = useMobile();
  const isWhosfan = useIsWhosfan();
  const isIframe = useIsIframe();
  const embedHost = useEmbedHost();

  console.log(isIframe)
  if (isIframe) {
    return null;
  }

  return (
    <React.Fragment>
      <HeaderNav />
    </React.Fragment>
  );
};

export default Header;
